import React from 'react';
import styled from 'styled-components';

import { Text } from '@companycam/slab-web';
import CCClipboard from 'components/shared/CCClipboard';
import { translate } from 'translations/i18n';
import toast from 'helpers/toast';
import { Steven } from 'helpers/steven';

type CopyEmbedCodeProps = {
  publicIdentifier?: string;
};

const BASE_URL = 'https://trusty.app';
const EMBED_URL = '/embed/project-map/';

const CodeContainer = styled.div`
  border: solid var(--cc_size_border_width_s) var(--cc_color_border_default);
  background-color: var(--cc_color_background_2);
  border-radius: var(--cc_size_border_radius_l);
  padding: var(--cc_size_spacing_m);
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_m);
  align-items: flex-start;
`;

const Pre = styled.pre`
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  width: 100%;
  font-size: var(--cc_size_text_xs);
  color: var(--cc_color_text_default);
  line-height: 1.5;
  margin: 0;
  padding: 0;
`;

const CopyEmbedCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_m);
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CopyEmbedCode = ({ publicIdentifier }: CopyEmbedCodeProps) => {
  if (!publicIdentifier) {
    return null;
  }

  const onSnippetCopy = () => {
    Steven.elementClicked({
      id: 'copy_embed_code',
      content: 'mapEmbedWizard.snippetButton',
      type: 'button',
      action: 'copy_map_embed_code_clicked',
    });
    toast.success(translate('common.copySuccess'));
  };

  const embedCode = `<iframe style="width: 100%; height: 100%" frameborder="0" src="${BASE_URL}${EMBED_URL}${publicIdentifier}" allow="fullscreen" loading="lazy"></iframe>`;

  return (
    <CopyEmbedCodeContainer>
      <TextContainer>
        <Text as="h3" size="m" weight={700} family="heading">
          {translate('mapEmbedWizard.snippetTitle')}
        </Text>
        <Text as="p" size="xs" family="heading">
          {translate('mapEmbedWizard.snippetBody')}
        </Text>
      </TextContainer>
      <CodeContainer>
        <Pre>{embedCode}</Pre>
        <CCClipboard
          copy={embedCode}
          className="ccb-blue-small"
          onCopy={onSnippetCopy}
        >
          {translate('mapEmbedWizard.snippetButton')}
        </CCClipboard>
      </CodeContainer>
    </CopyEmbedCodeContainer>
  );
};
